import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { AllPostJobsComp } from "../../components/allPostjobs";
import { AppDispatch, RootState } from "../../store";
import {
  decreasePage,
  getAllPostJobs,
  increasePage,
  jobsPerPage,
} from "../../features/postJob/getAllPostJobsSlice";
import { Pagination } from "../../components/General/helpers";
import { addQueryParams } from "../../utils/queryParams";
import { createSaveLaterAction } from "../../features/saveForLater/createSaveLateSlice";
import Overlay from "../../components/General/overlay";
import Loader from "../../components/General/Loader";
import {
  setCloseConfirmationModal,
  setOpenConfirmationModal,
  setPostJobId,
} from "../../features/general/generalSlice";
import StatCardSkeleton from "../../components/Skeletons/StatCardSkeleton";

const AllPostJobs = () => {
  const { allPostJobs, currentPage, pageSize, totalPages, postJobsLoading } =
    useSelector((store: RootState) => store.allPostJobsStore);
  const { isCreateSaveForLaterLoading } = useSelector(
    (store: RootState) => store.createSaveForLaterStore
  );
  const { postJobId } = useSelector((store: RootState) => store.generalStore);

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Initiate save for later modal
  const initialSaveForLater = (index: string) => {
    // console.log(index);
    dispatch(setPostJobId(index));
    dispatch(setOpenConfirmationModal());
  };

  // Save job for later
  const handleSaveForLater = () => {
    dispatch(setCloseConfirmationModal());

    const objectToSave = allPostJobs?.find(
      (each: any) => each._id === postJobId
    );
    // Save for later if only not in save-for-later page
    if (!pathname.includes("save-for-later")) {
      dispatch(createSaveLaterAction(objectToSave));
    }
  };

  // Navigate to single job page
  const handleJobDetails = (index: string) => {
    // console.log(index);
    navigate(`/dashboard/all-post-jobs/${index}`);
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentPage, pageSize);
  }, [pathname, currentPage, pageSize]);

  useEffect(() => {
    dispatch(getAllPostJobs({ isEngineering: false, currentPage, pageSize })); // Fetch all post jobs
  }, [currentPage, pageSize, dispatch]);

  if (postJobsLoading) {
    return <StatCardSkeleton />;
  }

  if (allPostJobs?.length < 1) {
    return (
      <NoJobsWrapper>
        <p className="no__job">NO JOBS YET</p>
      </NoJobsWrapper>
    );
  }

  return (
    <>
      {isCreateSaveForLaterLoading && (
        <Overlay>
          <Loader loaderStyle={""} />
        </Overlay>
      )}
      <AllPostJobsComp
        handleJobDetails={handleJobDetails}
        initialSaveForLater={initialSaveForLater}
        handleSaveForLater={handleSaveForLater}
      />
      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        pageSize={pageSize}
        currentPage={currentPage}
        totalPages={totalPages}
      />
    </>
  );
};

export default AllPostJobs;

const NoJobsWrapper = styled.div`
  .no__job {
    font-size: 24px;
    font-weight: bold;
  }
`;
